import get from 'lodash/get'
import { ReduxState } from 'app-types'

export const getEmail = (state: ReduxState): string => get(state, 'client.email')

export const getIsLoanAndTermSet = (state: ReduxState): boolean =>
  get(state, 'client.loanAmount') && get(state, 'client.term')

export const selectPhoneNumber = (state: ReduxState): string => get(state, 'client.phoneNumber')

export const selectIdentityStatus = (state: ReduxState): string =>
  get(state, 'client.minedIdentityStatus')
